// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}
body::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
body::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}
/* ::-webkit-scrollbar-track {
    backgroundColor: 'red',
    borderRadius: '6px'
  } */
`, "",{"version":3,"sources":["webpack://./src/assets/third-party/theme.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;;KAGK","sourcesContent":["::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 10px;\n}\nbody::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\nbody::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 10px;\n}\n/* ::-webkit-scrollbar-track {\n    backgroundColor: 'red',\n    borderRadius: '6px'\n  } */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
